import { useEffect, useRef } from 'react';

import { getOpParams } from '../getOpParams';

import { useIdentityAndUser } from './useIdentityAndUser';

declare let pendo: any;

/**
 * This hook waits for the current user info and then initializes Pendo Analytics
 * @see {@link https://support.pendo.io/hc/en-us/articles/360031862272-Install-Pendo-on-a-single-page-web-application}
 */
export const usePendoAnalytics = () => {
  const { orgId } = getOpParams();
  const { identity, isLoading, user, userId } = useIdentityAndUser({
    describeUserOptions: 'withRoles',
  });

  const initialized = useRef(false);

  useEffect(() => {
    if (isLoading) return;

    if (identity && orgId && typeof pendo !== 'undefined') {
      const namespace =
        identity.namespace?.namespaceType?.id === 1 // "master mode" account
          ? 'GLOBAL'
          : identity.namespace?.org?.id;

      const config = {
        visitor: {
          id: identity.id,
          user_id: userId,
          roles: user?.roles?.map(({ id }) => id).join(),
        },
        account: { id: orgId, namespace_org_id: namespace },
      };

      if (initialized.current) pendo.identify(config);
      else pendo.initialize(config);

      initialized.current = true;
    }
  }, [identity, isLoading, orgId, user?.roles, userId]);
};
